interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "AUD";
};

const AUD: Currency = Object.freeze({
  "displayName": "Australian Dollar",
  "numericCode": 36,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "before",
  "isoCode": "AUD",
  "symbol": "$"
});

export { AUD };
